var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"card-icon"},[_c('i',{class:_vm.image})])
}
var staticRenderFns = []

export { render, staticRenderFns }